// src/pages/Store/components/desktop/DesktopHeader.styles.ts
import styled from "styled-components";

export const Header = styled.div`
  position: sticky;
  top: 0;
  z-index: 40;
  background: ${(p) => p.theme.tokens.gradients.header};
  box-shadow: 0 2px 16px rgba(11, 92, 78, 0.22);
`;

export const Inner = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: 14px 28px;
  display: flex;
  align-items: center;
  gap: 22px;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const LocationChip = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${(p) => p.theme.tokens.colors.surface};
  padding: 8px 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.14);
`;

export const LocationText = styled.div`
  line-height: 1.1;
  white-space: nowrap;
`;

export const LocationLabel = styled.div`
  font-size: 10.5px;
  opacity: 0.8;
  font-weight: 700;
`;

export const LocationValue = styled.div`
  font-size: 13px;
  font-weight: 800;
`;

export const SearchBox = styled.div`
  flex: 1;
  max-width: 460px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${(p) => p.theme.tokens.colors.surface};
  border-radius: 13px;
  padding: 11px 15px;
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 14.5px;
  font-family: ${(p) => p.theme.tokens.font.family};
  font-weight: 600;
  color: ${(p) => p.theme.tokens.colors.ink};
  background: none;
  min-width: 0;
`;

export const ClearButton = styled.button`
  border: none;
  background: ${(p) => p.theme.tokens.colors.softBg};
  border-radius: 999px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${(p) => p.theme.tokens.colors.muted};
`;

export const CartButton = styled.button`
  position: relative;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 11px 17px;
  border-radius: 13px;
  border: none;
  background: rgba(255, 255, 255, 0.16);
  color: ${(p) => p.theme.tokens.colors.surface};
  cursor: pointer;
  font-weight: 800;
  font-size: 14px;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const OrdersButton = styled(CartButton)`
  background: none;
  border: 1.5px solid rgba(255, 255, 255, 0.35);
  padding: 9.5px 15px;
`;

export const Badge = styled.span`
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  border-radius: 10px;
  background: ${(p) => p.theme.tokens.colors.accentOrange};
  color: ${(p) => p.theme.tokens.colors.surface};
  font-size: 11.5px;
  font-weight: 900;
  display: flex;
  align-items: center;
  justify-content: center;
`;
